import { useTranslation } from 'react-i18next';

export default function HelpInfo({ helpInfo }) {
  const { t } = useTranslation();
  return (
    <>
      {helpInfo.length > 1 ? (
        <ul>
          {helpInfo.map((info, index) => {
            return info.length > 0 ? (
              <li key={index}>
                <span dangerouslySetInnerHTML={{ __html: t(info) }} />
              </li>
            ) : (
              <></>
            );
          })}
        </ul>
      ) : (
        <span dangerouslySetInnerHTML={{ __html: t(helpInfo[0]) }} />
      )}
    </>
  );
}
